export default __webpack_public_path__ + "assets/betrouwbaar.0a8dcc18.svg";